var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(-6295 3635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    transform: "translate(6295 -3635)",
    fill: "#fff",
    stroke: "#00ac94",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Calendar",
    "data-name": "Iconly/Bold/Calendar",
    transform: "translate(6303 -3627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M12.65,0a.753.753,0,0,1,.761.769h0v.75A4.694,4.694,0,0,1,17.989,6.49h0L18,14.916c0,3.138-1.968,5.069-5.128,5.074h0L5.152,20A4.781,4.781,0,0,1,.011,14.88h0L0,6.553A4.689,4.689,0,0,1,4.506,1.53h0V.781a.76.76,0,1,1,1.52,0h0v.7l5.865-.008v-.7A.747.747,0,0,1,12.65,0Zm.4,14.192h-.01a.833.833,0,0,0-.809.852.83.83,0,1,0,.818-.852Zm-8.136,0a.853.853,0,0,0-.809.861.815.815,0,1,0,.809-.861Zm4.068,0a.854.854,0,0,0-.809.861.815.815,0,1,0,.809-.861ZM4.912,10.595a.852.852,0,0,0-.808.861.815.815,0,1,0,.808-.861Zm4.069-.035a.853.853,0,0,0-.809.861.815.815,0,1,0,.809-.861Zm4.068,0a.828.828,0,0,0-.809.84h0v.011a.813.813,0,0,0,.84.8.825.825,0,0,0-.032-1.649ZM11.893,3.009l-5.865.008v.809a.76.76,0,1,1-1.52,0h0v-.77C2.583,3.251,1.518,4.383,1.52,6.551h0v.311l14.948-.02v-.35c-.042-2.149-1.121-3.276-3.056-3.444h0v.77a.76.76,0,1,1-1.52,0h0Z",
    fill: "#00ac94"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b380d63c49ba1314dfde3fbd19a7745f.svg";
export { ForwardRef as ReactComponent };